<template>
  <div class="app-container post-detail">
    <basic-container>
      <el-tabs v-model="activeName" @tab-click="onTabShow">
        <el-tab-pane label="基本资料" name="detail">
          <el-row class="post-detail-item">
            <el-col :span="2" class="head">ID:</el-col>
            <el-col :span="16">{{postDetail.id}}</el-col>
          </el-row>
          <el-row class="post-detail-item">
            <el-col :span="2">标题:</el-col>
            <el-col :span="16">{{postDetail.title}}</el-col>
          </el-row>
          <el-row v-if="postDetail.sourceUrl" class="post-detail-item" type="flex" align="bottom">
            <el-col :span="2">原文链接:</el-col>
            <el-col :span="16">
              <a :href="postDetail.sourceUrl" target="_blank" class="post-detail-item-button">
                {{postDetail.sourceUrl}}
              </a>
            </el-col>
          </el-row>
          <el-row class="post-detail-item" >
            <el-col :span="2">封面:</el-col>
            <el-col :span="16">
              <div class="post-cover-image" v-if="postDetail.coverImg">
                <img :src="postDetail.coverImg" v-viewer>
              </div>
            </el-col>
          </el-row>
          <el-row class="post-detail-item" >
            <el-col :span="2">正文:</el-col>
            <el-col :span="16">
              <div class="post-content" v-if="postDetail.contentType == 1">
                <div v-html="postDetail.content"></div>
              </div>
              <div class="post-content post-content-text" v-else>{{postDetail.content}}</div>
            </el-col>
          </el-row>
          <el-row class="post-detail-item">
            <el-col :span="2">发布者:</el-col>
            <el-col :span="16">
              <a href="javascript:void(0);" @click="toMemberDetail(postDetail.postedBy.id);"
                class="post-detail-item-button">
                {{ postDetail.postedByName }}</a>
            </el-col>
          </el-row>
          <el-row class="post-detail-item">
            <el-col :span="2">发布状态:</el-col>
            <el-col :span="16">{{ postDetail.publishStatus }}</el-col>
          </el-row>
          <el-row class="post-detail-item">
            <el-col :span="2">圈子:</el-col>
            <el-col :span="16">
              <a href="javascript:void(0);" @click="toCircleDetail(postDetail.circleId);"
                class="post-detail-item-button">
                {{ postDetail.circleName }}</a>
            </el-col>
          </el-row>
          <el-row class="post-detail-item">
            <el-col :span="2">类别:</el-col>
            <el-col :span="16">{{ postDetail.tagName }}</el-col>
          </el-row>
          <el-row class="post-detail-item">
            <el-col :span="2">主题:</el-col>
            <el-col :span="16">{{ postDetail.themeTagName }}</el-col>
          </el-row>
          <el-row class="post-detail-item">
            <el-col :span="2">标签:</el-col>
            <el-col :span="16">
              <el-tag size="small" v-for="(tag, index) in postDetail.postTags" :key="index" style="margin-right: 10px; margin-bottom: 6px;">{{ tag.tagName }}</el-tag>
            </el-col>
          </el-row>
          <el-row class="post-detail-item">
            <el-col :span="2">评论:</el-col>
            <el-col :span="16">
              <a href="javascript:void(0);" @click="toCommentList(id);"
                class="post-detail-item-button">
                {{ postDetail.commentCount }}</a>
            </el-col>
          </el-row>
          <el-row class="post-detail-item">
            <el-col :span="2">收藏:</el-col>
            <el-col :span="16">{{postDetail.favoriteCount}}</el-col>
          </el-row>
          <el-row class="post-detail-item">
            <el-col :span="2">点赞:</el-col>
            <el-col :span="16">{{postDetail.likeCount}}</el-col>
          </el-row>
          <el-row class="post-detail-item">
            <el-col :span="2">浏览量:</el-col>
            <el-col :span="16">{{postDetail.viewedCount}}</el-col>
          </el-row>
          <el-row class="post-detail-item">
            <el-col :span="2">状态:</el-col>
            <el-col :span="16">{{postDetail.status}}</el-col>
          </el-row>
          <el-row class="post-detail-item">
            <el-col :span="2">下架原因:</el-col>
            <el-col :span="16">{{postDetail.banComment}}</el-col>
          </el-row>
          <el-row class="post-detail-item">
            <el-col :span="2">置顶:</el-col>
            <el-col :span="16">{{postDetail.top? '是' : '否'}}</el-col>
          </el-row>
          <el-row class="post-detail-item">
            <el-col :span="2">置顶排序:</el-col>
            <el-col :span="16">{{postDetail.topPosition}}</el-col>
          </el-row>
          <el-row class="post-detail-item">
            <el-col :span="2">评论开关:</el-col>
            <el-col :span="16">{{postDetail.commentEnabled? '开启' : '关闭'}}</el-col>
          </el-row>
          <el-row class="post-detail-item">
            <el-col :span="2">过期:</el-col>
            <el-col :span="16">{{postDetail.expired ? '已过期' : '未过期'}}</el-col>
          </el-row>
          <el-row class="post-detail-item">
            <el-col :span="2">截止日期:</el-col>
            <el-col :span="16">{{postDetail.expireIn ? postDetail.expireIn : '长期有效'}}</el-col>
          </el-row>
          <el-row class="post-detail-item">
            <el-col :span="2">发布时间:</el-col>
            <el-col :span="16">{{postDetail.postTime}}</el-col>
          </el-row>
          <el-row class="post-detail-item">
            <el-col :span="2">修改时间:</el-col>
            <el-col :span="16">{{postDetail.lastEditTime}}</el-col>
          </el-row>
        </el-tab-pane>

        <el-tab-pane label="评论列表" name="comment">
          <el-table :data="commentData" stripe
            style="width:90%" tooltip-effect="dark">
            <!-- <el-table-column align="center" prop="id" label="ID" width="100"></el-table-column> -->
            <el-table-column align="center" prop="commentTime" label="评论时间" width="200"></el-table-column>
            <el-table-column align="center" prop="commentByName" label="评论者" width="200"></el-table-column>
            <el-table-column align="center" prop="commentToName" label="回复对象" width="200"></el-table-column>
            <el-table-column prop="content" label="评论内容"></el-table-column>
          </el-table>
          <el-pagination :page-size="commentPage.pageSize"
                         :page-sizes="commentPage.pageSizes"
                         :current-page="commentPage.currentPage"
                         :total="commentPage.total"
                         :layout="commentPage.layout"
                         @current-change="commentCurrentChange"
                         @size-change="commentSizeChange">
          </el-pagination>
        </el-tab-pane>

        <el-tab-pane label="点赞列表" name="like">
          <el-table :data="postLikeData" stripe
            style="width:90%" tooltip-effect="dark">
            <el-table-column align="center" prop="likeTime" label="点赞时间" width="200"></el-table-column>
            <el-table-column align="center" prop="nickname" label="用户"></el-table-column>
          </el-table>
          <el-pagination :page-size="postLikePage.pageSize"
                         :page-sizes="postLikePage.pageSizes"
                         :current-page="postLikePage.currentPage"
                         :total="postLikePage.total"
                         :layout="postLikePage.layout"
                         @current-change="postLikeCurrentChange"
                         @size-change="postLikeSizeChange">
          </el-pagination>
        </el-tab-pane>
      </el-tabs>

    </basic-container>
  </div>
</template>

<script>
import {getPost, fetchPostCommentList, fetchPostLikeList} from '@/api/post/post'
import postLikeList from '@/mixins/post/like-list';
import { downloadOSSFile } from '@/api/basic/aliyunoss';
import { matchUrl } from '@/util/util';

const initDetail = vm => {
  getPost(vm.id).then(response => {
    let data = response.data
    if (response.status == 200) {
      formatPostDetail(vm.postDetail, data.data);
    } else {
      vm.$message({
        showClose: true,
        message: '无法查看该帖子详情',
        type: 'error'
      });
    }
  }).catch(error => {
    vm.$message({
      message: '获取帖子详情失败',
      type: 'error'
    });
  });
}

const formatPostDetail = (vm, data) => {
  // 帖子详情格式化
  vm.id = data.id
  vm.banComment = data.banComment
  if (!data.title) vm.title = "--";
  else vm.title = data.title;
  vm.contentType = data.contentType;

  if (!data.content) vm.content = "--";
  else vm.content = data.content;
  vm.sourceUrl = data.sourceUrl;
  if (!data.postedBy) vm.postedByName = "--";
  else if (!data.postedBy.name) vm.postedByName = "--";
  else {
    vm.postedByName = data.postedBy.name;
    vm.postedBy = data.postedBy;
  }
  if (!data.tagName) vm.tagName = "--";
  else vm.tagName = data.tagName;
  if (data.circleId) vm.circleId = data.circleId
  if (!data.circleName) vm.circleName = "--";
  else vm.circleName = data.circleName;

  if (data.isActive == 0 ) vm.status = "已删除";
  else if (data.isBanned == 0) vm.status = "已上架";
  else if (data.isBanned == 1) vm.status = "已下架";
  else vm.status = "--";

  if (data.lastEditTime == undefined || data.lastEditTime == null) vm.lastEditTime = "--";
  else vm.lastEditTime = data.lastEditTime;

  if (!data.commentCount) vm.commentCount = 0;
  else vm.commentCount = data.commentCount;

  vm.favoriteCount = data.favoriteCount || 0;
  vm.likeCount = data.likeCount || 0;
  vm.viewedCount = data.viewedCount || 0;
  if (!data.postTime) vm.postTime = "--";
  else vm.postTime = data.postTime;

  if (data.publishStatus === 1) {
    vm.publishStatus = '已发布';
  } else {
    vm.publishStatus = '草稿';
  }

  vm.isAnonymous = data.isAnonymous;
  vm.commentEnabled = data.commentEnabled;
  vm.top = data.isTop;

  vm.themeTagName = data.themeTagName;
  vm.postTags = data.postTags;
  vm.expired = data.expired;
  vm.expireIn = data.expireIn;
  vm.topPosition = data.topPosition;
  vm.coverImg = data.coverImg;
}

export default {
  mixins: [postLikeList],
  data() {
    return {
      id: 0,
      activeName: "detail",
      postDetail:{
        id: undefined,
        title: "",
        contentType: undefined,
        content: "",
        postedBy: undefined,
        postedByName: "",
        tagName: "",
        circleId: undefined,
        circleName: "",
        status: "",
        isActive: "",
        commentCount: 0,
        favoriteCount: 0,
        postTime: "",
        isAnonymous: 0,
        themeTagName: "",
        banComment: ""
      },
      // 评论详情窗口
      commentData:[],
      commentPage: {
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 20, // 每页显示多少条,
        pageSizes: [10, 20, 30, 40, 50, 100],
        layout: "total, sizes, prev, pager, next, jumper"
      },
      isBindDownloadEvent: false,
    }
  },
  watch: {
    $route() {
      this.id = this.$route.params.id
      initDetail(this)
    }
  },
  mounted() {
    this.id = this.$route.params.id
    initDetail(this)
  },
  updated() {
    this.downloadFile();
  },
  methods: {
    onTabShow(tab) {
      switch (tab.name) {
        case 'comment':
          this.getCommentList();
          break;
        case 'like':
          this.initPostLike();
          break;
      }
    },
    getCommentList(){
      // 获取帖子的评论列表
      let params = {
        current: this.commentPage.currentPage,
        size: this.commentPage.pageSize,
        postId: this.id
      }
      fetchPostCommentList(params).then(response => {
        if (response.data.data != null) {
          this.commentData = response.data.data.records
          this.commentData.forEach(comment => {
            comment.commentByName = comment.commentBy.name
            comment.commentToName = comment.commentTo ? comment.commentTo.name || '--' : '--'
          })
          this.commentPage.total = response.data.data.total
        } else  {
          this.commentData = null
          this.commentPage.total = 0
        }
      }).catch(error => {
        this.$message({
          showClose: true,
          message: '获取该帖子的评论列表失败',
          type: 'error'
        })
      })
    },
    commentCurrentChange(val) {
      this.commentPage.currentPage = val;
      this.getCommentList();
    },
    commentSizeChange(val) {
      this.commentPage.pageSize = val;
      this.getCommentList();
    },
    toMemberDetail(postedById) {
      // 帖子详情里点击发布者姓名，链接转到该发布者的会员详情
      this.$router.push({
        path: "/upms/member/detail/" + postedById,
      })
    },
    toCircleDetail(circleId) {
      // 帖子详情里点击圈子名称，链接转到该圈子的详情页面
      this.$router.push({
        path: "/post/circle/detail/" + circleId,
      })
    },
    toCommentList(curPostId) {
      // 帖子详情里点击评论数，链接转到该帖子的评论列表
      this.$router.push({
        path: "/post/comment",
        query: {
          postId: curPostId
        }
      })
    },
    downloadFile() {
      const fileList = document.querySelectorAll('.post-content .mc-file');
      if (fileList.length > 0 && !this.isBindDownloadEvent) {
        this.isBindDownloadEvent = true;
        fileList.forEach((item) => {
          item.onclick = () => {
            this.$message({
              message: '等待下载',
              type: 'info',
            });
            const link = document.createElement('a');
            let itemHref = item.getAttribute('href');
            link.download = item.download;
            if (matchUrl(itemHref)) {
              itemHref = itemHref.split('/').slice(3).join('/');
            }
            const param = { filePath: itemHref };
            downloadOSSFile(param).then((res) => {
              if (res.data) {
                const address = URL.createObjectURL(res.data);
                link.href = address;
                link.click();
                if (typeof URL.revokeObjectURL === 'function') {
                  URL.revokeObjectURL(address);
                }
              }
            });
            return false;
          };
        });
      }
    },
  }
}
</script>

<style lang="scss" scoped>

.post-detail {
  .post-detail-item {
    font-size: 16px;
    margin: 10px 0;
    &-button {
      margin: 0 0;
      color: #409EFF;
      text-align: center;
    }
  }
  &-item-picture-right {
    font-size: 16px;
    display: table-cell;
    &-item {
      display: inline-block;
      margin-right: 5px;
      margin-top: 5px;
    }
    &-poster {
      position: relative;
      &-icon {
        position: absolute;
        color: #ffffff;
        top: 30px;
        left: 30px;
        font-size: 40px;
      }
      &-icon:hover {
        color: rgba(249, 129, 55, 0.9);
      }
    }
  }
}

.vue-poll .ans-cnt .ans .bg{
  position: absolute;
  width: 0;
  top: 0;
  left: 0;
  bottom: 0;
  z-index: 0;
  background-color: #409eff;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}
.post-cover-image {
  display: flex;
  width: fit-content;
  border: 1px solid #eee;
  padding: 10px;
  img {
    width: 356px;
    height: 200px;
    object-fit: cover;
    max-width: 100%;
  }
}
.post-content {
  border: 1px solid #eee;
  padding: 10px;
  /deep/ .mc-img {
    max-width: 100%;
  }
  /deep/ a {
    color: #105b89;
    text-decoration: underline;
  }
  /deep/ p {
    color: #000000;
  }
  /deep/ .mc-file {
    display: flex;
    align-items: flex-start;
    font-size: 14px;
    padding: 3px;
    line-height: 20px;
    text-decoration: none;
    color: #01396B;
    .mc-file-icon {
      background: url(../../../static/images/editor/file.svg) no-repeat center;
      background-size: 80%;
      display: inline-block;
      width: 20px;
      height: 20px;
      margin-right: 8px;
    }
  }
  /deep/ table {
    margin: 1em 0;
  }
}

.post-content-text {
  white-space: pre-wrap;
}

.mc-img {
  max-width: 100%;
}
/deep/.el-dialog {
  box-shadow: none;
  background: none;
}
/deep/.el-dialog__headerbtn {
  right: -20px;
  font-size: 20px;
}
</style>
